const versions = require("./versions")

const getCurrentEnvironment = () => {
  const activeEnv =
    process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "development"
  let environment = activeEnv.toLowerCase()
  if (environment === "fr") {
    environment = "eu"
  }
  if (environment !== "us" && environment !== "uk" && environment !== "eu") {
    environment = "us"
  }

  return environment
}

const getCurrencySign = () => {
  const environment = getCurrentEnvironment()
  
  let currencySign = "$"
  if (environment === "uk") {
    currencySign = "£"
  } else if (environment === "eu" || environment === "fr") {
    currencySign = "€"
  }

  return currencySign;
}

const getCurrentVersion = () => {
  const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us"
  const activeVersion = versions[activeEnv]
  let currentVersion

  if (activeVersion) {
    currentVersion = activeVersion
  } else {
    currentVersion = versions.uk
  }

  return currentVersion
}

const getActiveEnv = () => {
  const activeEnv =
    process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "us"

  return activeEnv
}

module.exports = {
  getCurrentEnvironment: getCurrentEnvironment,
  getCurrentVersion: getCurrentVersion,
  getActiveEnv: getActiveEnv,
  getCurrencySign: getCurrencySign
}
